import React, { useState, useEffect } from 'react';
import { Offcanvas, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withPermission from '../../utils/withPermission';

const LicenseTypeModal = ({
    showModal,
    handleClose,
    addLicenseType,
    editLicenseType,
    selectedTypeId,
    selectedTypeData,
}) => {
    const [typeData, setTypeData] = useState({
        name: '',
        key: '',
        description: '',
        type: 'license',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (selectedTypeData) {
            setTypeData({
                name: selectedTypeData.name || '',
                key: selectedTypeData.key || '',
                description: selectedTypeData.description || '',
                type: selectedTypeData.type || 'license',
            });
        } else {
            setTypeData({
                name: '',
                description: '',
                type: 'license',
            });
        }
    }, [selectedTypeData, showModal]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTypeData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: undefined }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!typeData.name) newErrors.name = 'Name is required';
        if (!typeData.key) newErrors.key = 'Key is required';
        return newErrors;
    };

    const [loading, setLoading] = useState(false);

    const handleSave = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            if (selectedTypeData) {
                await editLicenseType(selectedTypeData.id, typeData);
            } else {
                await addLicenseType(typeData);
            }
            handleClose();
        } catch (error) {
            if (error?.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                Swal.fire('Error', 'Failed to save License Type', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            
            <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '600px' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{selectedTypeData ? 'Edit License Type' : 'Add License Type'}</Offcanvas.Title>
                </Offcanvas.Header>
                <hr style={{ margin: 0 }} /><br />

                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: '13px' }}>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={typeData.name}
                                onChange={handleChange}
                                isInvalid={!!errors.name}
                                style={{ fontSize: '13px', borderRadius: '14px', height: '39px' }}
                            />
                            {errors.name && <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>{errors.name}</Form.Control.Feedback>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: '13px' }}>Key</Form.Label>
                            <Form.Control
                                type="text"
                                name="key"
                                value={typeData.key}
                                onChange={handleChange}
                                isInvalid={!!errors.key}
                                style={{ fontSize: '13px', borderRadius: '14px', height: '39px' }}
                            />
                            {errors.key && <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>{errors.key}</Form.Control.Feedback>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: '13px' }}>Type</Form.Label>
                            <Form.Select
                                name="type"
                                value={typeData.type}
                                onChange={handleChange}
                                style={{ fontSize: '13px', borderRadius: '14px', height: '39px' }}
                            >
                                <option value="">Select Type</option>
                                <option value="license">License</option>
                                <option value="module">Modules</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: '13px' }}>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={typeData.description}
                                onChange={handleChange}
                                style={{ fontSize: '13px', borderRadius: '14px' }}
                            />
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="p-3 d-flex justify-content-end border-top">
                    <Button variant="secondary" onClick={handleClose} className="me-2" disabled={loading} style={{ borderRadius: '14px' }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave} disabled={loading} style={{ borderRadius: '14px' }}>
                        {loading ? 'Saving...' : 'Save'}
                    </Button>
                </div>
            </Offcanvas>
        </>
    );
};

export default LicenseTypeModal;
